import { fanduel as fd } from "@fanduel/formation-tokens";
import cx from "classnames";
import ordinal from "ordinal";
import styles from "../nflMatchupCard.module.scss";
interface PreGameStatLineProps {
  homeStat: number;
  awayStat: number;
  homeRank: number;
  awayRank: number;
  rankOutOfNum?: number; // what number of teams is the stat ranked out of eg 32 for NFL
  statName: string;
  homeColor?: string | null;
  awayColor?: string | null;
  isRank?: boolean;
}

export function hideZeroStat(stat: number, isStat: boolean, width: number) {
  if (stat === 0 && isStat) {
    return 0;
  } else return width;
}

const PregameStatLine = ({
  homeStat,
  awayStat,
  homeRank,
  awayRank,
  rankOutOfNum = 32,
  statName,
  homeColor,
  awayColor,
  isRank = false,
}: PreGameStatLineProps) => {
  if (homeRank === 0) {
    homeRank = rankOutOfNum;
  }
  if (awayRank === 0) {
    awayRank = rankOutOfNum;
  }
  let homeWidth = 100 - (homeRank / rankOutOfNum - 1 / rankOutOfNum) * 100;
  let awayWidth = 100 - (awayRank / rankOutOfNum - 1 / rankOutOfNum) * 100;
  homeWidth = hideZeroStat(homeStat, !isRank, homeWidth);
  awayWidth = hideZeroStat(awayStat, !isRank, awayWidth);
  return (
    <div className={styles.pregameStat}>
      <p className={styles.statRank}>
        {isRank ? ordinal(Math.round(awayStat)) : Math.round(awayStat)}
      </p>
      <div className={styles.statLine}>
        <div
          className={styles.fillBar}
          style={{
            right: 0,
            width: `${awayWidth}%`,
            backgroundColor: awayColor ?? fd.colors.brandPrimaryDefault,
          }}
        />
      </div>
      <h3>{statName}</h3>
      <div className={styles.statLine}>
        <div
          className={styles.fillBar}
          style={{
            width: `${homeWidth}%`,
            backgroundColor: homeColor ?? fd.colors.brandPrimaryShade,
          }}
        />
      </div>
      <p className={cx(styles.leftStat, styles.statRank)}>
        {isRank ? ordinal(Math.round(homeStat)) : Math.round(homeStat)}
      </p>
    </div>
  );
};

export default PregameStatLine;
